module.exports = __webpack_public_path__ + "static/qoipr-69669ed46dec8e036e8162b4b5fd8ad1.jpg";